<template>
  <div class="news">
    <section class="page-hero">
      <div class="container">
        <span class="eyebrow eyebrow-light">{{ $t('news.hero.eyebrow') }}</span>
        <h1>{{ $t('news.hero.title') }}</h1>
        <p>{{ $t('news.hero.subtitle') }} <em>{{ $t('news.hero.note') }}</em></p>
      </div>
    </section>

    <section class="section">
      <div class="container news-layout">
        <div>
          <h2 class="col-head">{{ $t('news.latestHead') }}</h2>
          <div class="card news-item" v-for="n in latest" :key="n.key">
            <IconBadge :icon="n.icon" :tone="n.tone" size="sm" />
            <div>
              <span class="news-date">{{ $t(`news.${n.key}.date`) }}</span>
              <h3>{{ $t(`news.${n.key}.title`) }}</h3>
              <p>{{ $t(`news.${n.key}.text`) }}</p>
            </div>
          </div>
        </div>

        <div>
          <h2 class="col-head">{{ $t('news.upcomingHead') }}</h2>
          <div class="card news-item" v-for="e in upcoming" :key="e">
            <IconBadge icon="calendar" tone="amber" size="sm" />
            <div>
              <span class="news-date">{{ $t(`news.${e}.date`) }}</span>
              <h3>{{ $t(`news.${e}.title`) }}</h3>
              <p>{{ $t(`news.${e}.text`) }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import IconBadge from '@/components/IconBadge.vue';

export default {
  name: 'NewsEvents',
  components: { IconBadge },
  data() {
    return {
      latest: [
        { key: 'l1', icon: 'users', tone: 'rose' },
        { key: 'l2', icon: 'paw', tone: 'amber' },
        { key: 'l3', icon: 'droplet', tone: 'navy' },
      ],
      upcoming: ['u1', 'u2', 'u3', 'u4'],
    };
  },
};
</script>

<style scoped>
.page-hero { background: linear-gradient(135deg, var(--charcoal-dark), var(--charcoal)); color: #fff; padding: 76px 0; text-align: center; }
.eyebrow-light { color: #8FDDD8; text-transform: uppercase; letter-spacing: 1.5px; font-weight: 700; font-size: 0.8rem; }
.page-hero h1 { font-size: clamp(1.7rem, 3.4vw, 2.3rem); margin: 12px 0 10px; }
.page-hero p { color: rgba(255,255,255,0.88); margin: 0; }
.page-hero em { color: #8FDDD8; font-style: normal; font-size: 0.85rem; }

.news-layout { display: grid; grid-template-columns: 1fr 1fr; gap: 40px; }
@media (max-width: 860px) { .news-layout { grid-template-columns: 1fr; } }
.col-head { color: var(--charcoal); font-size: 1.15rem; margin-bottom: 18px; }
.news-item { display: flex; gap: 16px; align-items: flex-start; margin-bottom: 16px; }
.news-date { font-size: 0.78rem; font-weight: 700; letter-spacing: 0.5px; text-transform: uppercase; color: var(--brand-teal); }
.news-item h3 { margin: 4px 0 6px; font-size: 1.02rem; color: var(--charcoal); }
.news-item p { margin: 0; color: var(--muted); font-size: 0.9rem; }
</style>
